// import React from 'react'

// const AddSubcategory = () => {
//   return (
//     <div>

//     </div>
//   )
// }

// export default AddSubcategory

// import React from 'react'

// const AddCategory = () => {
//   return (
//     <div>

//     </div>
//   )
// }

// export default AddCategory

//-------imports-----------
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  FormControl,
  Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,
  Autocomplete,
  Chip,
} from "@mui/material";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { useLocation } from "react-router-dom";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import {
  InvCategory_01,
  InvSubCategory_01,
  SETTINGS_API_08,
  SETTINGS_API_26,
} from "../../api/ApiModel";
import { useSelector } from "react-redux";
const names = [
  { label: "Food Items", value: "F" },
  { label: "Beverages", value: "B" },
];

const AddSubcategory = () => {
  //----------------hooks---------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error1, setError1] = useState(null);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [dataitem, setDataitem] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const [errors, setErrors] = useState({});
  const [datacat, setDatacat] = useState([]);
  const isEdit = location.state?.actionText === "Edit";
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    catcode: "",
    subcatcode: "",
    subcatname: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        catcode: selectedItem.CATCODE || "",
        subcatcode: selectedItem.SUBCATCODE || "0",
        subcatname: selectedItem.SUBCATNAME || "",
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    fetchData();
  }, []);

  //------------------function------------

  const fetchData = async () => {
    try {
      const result = await externalgetApi(InvSubCategory_01, "get", {
        COMPCODE,
        CATCODE: "1",

        STS: CON_STATUS_ACTIVE,
      });
      setDataitem(result);
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(InvCategory_01, "get", {
          COMPCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setDatacat(result);
        console.log("result", result);
      } catch (err) {
        setError(err);
      }
    };

    fetchData();
  }, []);
  // handlers
const cleanInputValue = (name, value) => {
  if (typeof value !== "string") return value;

  // Example: clean leading spaces for all inputs, or per field if needed
  return value.replace(/^\s+/, ""); // remove leading spaces
};

const handleInputChange = (e) => {
  const { name, value } = e.target;

  // Auto-clean the input (remove leading spaces)
  const cleanedValue = cleanInputValue(name, value);
  const trimmedValue = typeof cleanedValue === "string" ? cleanedValue.trim() : cleanedValue;

  // Prevent initial space only (optional after clean)
  if (typeof value === "string" && value.length === 1 && value[0] === " ") {
    return;
  }

  // Validate max length
  if (typeof cleanedValue === "string" && cleanedValue.length > 30) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "Input cannot exceed 30 characters.",
    }));
    return;
  }

  // Validate empty or space-only input
  if (typeof cleanedValue === "string" && trimmedValue === "") {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "Input cannot be empty or just spaces.",
    }));
  } else {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  }

  // Always update with the cleaned value
  setSelectedItemDetails((prevDetails) => ({
    ...prevDetails,
    [name]: cleanedValue,
  }));
};

  //postapi
  const handleConfirmClick = async () => {
    const { catcode, subcatname } = selectedItemDetails;

    const requiredFields = [
      { name: "catcode", value: catcode, label: "Category Name" },
      { name: "subcatname", value: subcatname, label: "Subcategory Name" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });

      setErrors(newError);
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage);
      setOpenErrorSnackbar(true);
      return;
    }

if (dataitem) {
  const isDuplicate = dataitem.some((item) => {
    return (
      item.CATCODE === selectedItemDetails.catcode && // Only check within the selected category
      
      item.SUBCATNAME.toLowerCase() === subcatname.toLowerCase() &&
      item.SUBCATCODE !== selectedItemDetails.subcatcode // Allow editing without self-match
    );
  });

  if (isDuplicate) {
    setSnackbarMessage("Subcategory already exists under this Category.");
    setOpenErrorSnackbar(true);
    return;
  }
}

    const staticValues = {
      COMPCODE,

      STS: CON_STATUS_ACTIVE,
    };

    const payload = {
      ...selectedItemDetails,
      catcode: String(selectedItemDetails.catcode) || "",
      ...staticValues,
      subcatcode: String(selectedItemDetails.subcatcode) || "0",
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(InvSubCategory_01, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        catcode: "",
        subcatcode: "0",
        subcatname: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/Vinvsubcategory");
    }, 2000);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      catname: "",
      colorcode: "",
      subcatcode: "0",
      subcatname: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const gotToView = () => {
    navigate("/Vinvsubcategory");
  };
  //validations

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Setting</Link>
                <Link underline="hover"> Create Subcategory</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit ? "Edit Subcategory " : "Create Subcategory ",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid container item spacing={2} xs={12} sm={12} md={12} lg={12}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Autocomplete
                options={Array.isArray(datacat) ? datacat : []}
                getOptionLabel={(option) => option.CATNAME || ""}
                disableClearable
                value={
                  Array.isArray(datacat)
                    ? datacat.find(
                        (item) => item.CATCODE === selectedItemDetails.catcode
                      ) || null
                    : null
                }
               onChange={(event, newValue) => {
  setSelectedItemDetails((prev) => ({
    ...prev,
    catcode: newValue ? (newValue.CATCODE) : "",
  }));
  if (newValue) {
    setErrors((prev) => ({
      ...prev,
      catcode: "", // Clear the error
    }));
  }
}}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="catcode"
                    label={
                      <span>
                        Category Name<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    variant="outlined"
                  error={Boolean(errors.catcode)}
      helperText={errors.catcode}
                    size="small"
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label={
                  <span>
                    Subcategory Name
                    <span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                name="subcatname"
                value={selectedItemDetails.subcatname}
                onChange={handleInputChange}
                error={Boolean(errors.subcatname)}
                helperText={errors.subcatname}
              />
            </Grid>
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default AddSubcategory;
